import React, { useEffect, useState } from "react";
import { Accessibility } from "lucide-react";

const AccessibilityToolbar = () => {
  const [open, setOpen] = useState(false);
  const [fontSize, setFontSize] = useState(100);
  const [lineHeight, setLineHeight] = useState(1.6);
  const [highContrast, setHighContrast] = useState(false);
  const [spacing, setSpacing] = useState(false);

  useEffect(() => {
    document.documentElement.style.fontSize = `${fontSize}%`;
  }, [fontSize]);

  useEffect(() => {
    document.body.style.lineHeight = String(lineHeight);
  }, [lineHeight]);

  useEffect(() => {
    document.body.classList.toggle("a11y-high-contrast", highContrast);
  }, [highContrast]);

  useEffect(() => {
    document.body.classList.toggle("a11y-spacing", spacing);
  }, [spacing]);

  const reset = () => {
    setFontSize(100);
    setLineHeight(1.6);
    setHighContrast(false);
    setSpacing(false);
  };

  return (
    <>
      {open && (
        <div className="a11y-toolbar" role="region" aria-label="Accessibility Controls">
          <div className="a11y-header">Accessibility</div>
          <div className="a11y-control">
            <label htmlFor="a11y-font">Font Size</label>
            <input id="a11y-font" type="range" min="80" max="160" step="10" value={fontSize} onChange={(e) => setFontSize(Number(e.target.value))} />
            <span className="a11y-val">{fontSize}%</span>
          </div>
          <div className="a11y-control">
            <label htmlFor="a11y-lh">Line Height</label>
            <input id="a11y-lh" type="range" min="1.2" max="2.4" step="0.1" value={lineHeight} onChange={(e) => setLineHeight(Number(e.target.value))} />
            <span className="a11y-val">{lineHeight.toFixed(1)}</span>
          </div>
          <div className="a11y-control">
            <input id="a11y-hc" type="checkbox" checked={highContrast} onChange={(e) => setHighContrast(e.target.checked)} />
            <label htmlFor="a11y-hc">High Contrast</label>
          </div>
          <div className="a11y-control">
            <input id="a11y-sp" type="checkbox" checked={spacing} onChange={(e) => setSpacing(e.target.checked)} />
            <label htmlFor="a11y-sp">More Spacing</label>
          </div>
          <button className="a11y-button" onClick={reset}>Reset All</button>
        </div>
      )}
      <button className="a11y-toggle" aria-label="Toggle accessibility controls" onClick={() => setOpen((o) => !o)}>
        <Accessibility size={24} />
      </button>
    </>
  );
};

export default AccessibilityToolbar;
